const INITIAL_STATE = {
  all: [],
  current: null,
}

export default {
  namespaced: true,
  state: {
    ...INITIAL_STATE,
  },
  getters: {
    find: (state) => (id) => state.find(el => el.id === id),
  },
  mutations: {
    setCurrent: (state, { item }) => {
      state.current = item
    },
    add: (state, { item, prepend = false }) => {
      if (prepend) {
        state.all.unshift(item)
      } else {
        state.all.push(item)
      }
    },
    remove: (state, { id }) => {
      let idx = state.all.findIndex(el => el.id === id)
      state.all.splice(idx, 1)
    },
    
  },
  actions: {
    all: ({ dispatch, getters, commit }) => {
      let headers = {
        'Content-Type': 'application/json',
      }
      Object.assign(headers, getters.getAuthHeader)
      
      return dispatch('apiRequest', {
        actionPath: '/api/devices/all.json',
        method: 'get',
        headers: headers,
        
      }, { root: true }).then(result => {
        
        commit('addClient', result)
        
        return Promise.resolve(result)
      })
    },
    delete: ({ dispatch, getters, commit }, { id }) => {
      let headers = {
        'Content-Type': 'application/json',
      }
      Object.assign(headers, getters.getAuthHeader)
      
      return dispatch('apiRequest', {
        actionPath: ['/api/devices/delete/', id, '.json'].join(''),
        method: 'delete',
        headers: headers,
        
      }, { root: true }).then(result => {
        
        commit('addClient', result)
        
        return Promise.resolve(result)
      })
    },
    didUpdate: ({ dispatch, getters, commit }) => {
      let headers = {
        'Content-Type': 'application/json',
      }
      Object.assign(headers, getters.getAuthHeader)
      
      return dispatch('apiRequest', {
        actionPath: '/api/devices/didUpdate.json',
        method: 'post',
        headers: headers,
        
      }, { root: true }).then(result => {
        
        commit('addClient', result)
        
        return Promise.resolve(result)
      })
    },
    register: (
      { dispatch, rootGetters, commit }, {
        identifier,
        username,
        password,
        terms_accepted,
        platform,
        app_id,
        name,
        system,
      }) => {
      let headers = {
        'Content-Type': 'application/json',
      }
      Object.assign(headers, rootGetters['Api/getAuthHeader'])
      
      return dispatch('Api/apiRequest', {
        actionPath: '/api/devices/register.json',
        method: 'post',
        headers: headers,
        data: {
          identifier,
          username,
          password,
          terms_accepted,
          platform,
          app_id,
          name,
          system,
        },
      }, { root: true }).then(result => {
        
        // commit('addClient', result);
        
        return Promise.resolve(result)
      })
    },
  },
}
